import { MainLayout } from '../../layouts/MainLayout';
import { WhyUsHero } from '../../components/why-us/WhyUsHero';
import { AnswerSection } from '../../components/why-us/AnswerSection';
import { ProblemSection } from '../../components/why-us/ProblemSection';
import { ComparisonSection } from '../../components/why-us/ComparisonSection';
import { NativeSection } from '../../components/why-us/NativeSection';
import { ExperienceSection } from '../../components/why-us/ExperienceSection';
import { CustomerCareSection } from '../../components/why-us/CustomerCareSection';
import { WhyUsProducts } from '../../components/why-us/WhyUsProducts';
import { ZonesSection } from '../../components/why-us/ZonesSection';
import { FaqSection } from '../../components/why-us/FaqSection';
import { FinalCTA } from '../../components/why-us/FinalCTA';
import { SEOBlock } from '../../components/why-us/SEOBlock';
import type { WhyUsLandingProps } from '../../types/whyus-landing';

export default function WhyUs(props: WhyUsLandingProps) {
  return (
    <MainLayout>
      <WhyUsHero
        h1={props.h1}
        brandLine={props.brand_line}
        dek={props.dek}
        produceUrl={props.links.produce}
      />
      <AnswerSection paragraphs={props.answer} />
      <ProblemSection problems={props.problems} />
      <ComparisonSection rows={props.comparison} changomas={props.changomas} />
      <NativeSection paragraphs={props.native} />
      <ExperienceSection items={props.experience} />
      <CustomerCareSection items={props.care} />
      <WhyUsProducts basket={props.basket} />
      <ZonesSection zones={props.zones} />
      <FaqSection faqs={props.faqs} />
      <FinalCTA
        loginUrl={props.loginUrl}
        produceUrl={props.links.produce}
        bolsonUrl={props.links.bolson}
        cta={props.cta}
      />
      <SEOBlock
        canonical={props.canonical}
        title={props.title}
        description={props.description}
        seo={props.seo}
        jsonLd={props.jsonLd}
      />
    </MainLayout>
  );
}
